import React from 'react'
import {
  useLocationContext,
  useRPC,
  useRPCServerEventHandler,
} from '@therms/react-modules'
import {RPCDocs, RPCs} from '@therms/rpc-gateway'
import {Loading} from '@therms/atalaya'
import {LocationTaskTodoListCard} from '../../../../LocationTaskTodoListCard'

export function LocationTaskTodoList() {
  const {locationId} = useLocationContext(true)
  const {call, data, isCalling} = useRPC<
    RPCDocs.Locations.GetLocationTaskTodos.v1.Args,
    RPCDocs.Locations.GetLocationTaskTodos.v1.Data
  >(RPCs.Locations.GetLocationTaskTodos.v1, {
    locationIds: [locationId],
  })

  useRPCServerEventHandler('LocationTaskTodoDeleted', (evt, eventData) => {
    console.log({eventData, evt})
    if (data?.locationTaskTodos.some(({id}) => id === eventData.taskTodoId))
      call()
  })

  useRPCServerEventHandler('LocationTaskTodoStatusChanged', (evt, eventData) => {
    if (data?.locationTaskTodos.some(({id}) => id === eventData.taskTodoId))
      call()
  })

  return (
    <div className="gap-sm relative flex flex-col">
      {isCalling && !data?.locationTaskTodos && <Loading overlay />}

      {data?.locationTaskTodos?.map((todo) => (
        <div className="bg-surface rounded" key={todo.id}>
          <LocationTaskTodoListCard locationTaskTodo={todo} />
        </div>
      ))}
    </div>
  )
}
